import React from 'react';
import { ShieldIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function Garantia() {
  return <section className="py-16 bg-orange-50/70" data-id="element-89">
      <div className="max-w-4xl mx-auto px-4" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gray-900 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-91">
          {/* Decorative badge */}
          <div className="absolute -top-10 -right-10 text-orange-900/20" data-id="element-92">
            <ShieldIcon className="w-64 h-64" data-id="element-93" />
          </div>

          <div className="relative z-10 flex flex-col items-center" data-id="element-94">
            <div className="bg-orange-400 p-4 rounded-full mb-6 shadow-lg" data-id="element-95">
              <ShieldIcon className="w-12 h-12 text-gray-900" data-id="element-96" />
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-white uppercase mb-4" data-id="element-97">
              Garantía de 7 días
            </h2>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed font-medium" data-id="element-98">
              "Si el material no cumple tus expectativas, te devolvemos el 100%
              de tu dinero. Sin preguntas, sin vueltas. Tu compra está
              protegida."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}